<template>
  <svg height="20" width="20" viewBox="0 0 20 20">
    <circle r="10" cx="10" cy="10" fill="white" />
    <circle
      class="dwp-transition-all dwp-duration-500"
      r="5"
      cx="10"
      cy="10"
      fill="transparent"
      stroke="currentColor"
      stroke-width="10"
      :stroke-dasharray="dasharray"
      transform="rotate(-90) translate(-20)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  computed: {
    dasharray() {
      return `${(this.percentage * 31.4) / 100} 31.4`;
    }
  }
};
</script>